import { Box, Select, MenuItem, FormControl } from '@material-ui/core';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import React, { ChangeEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Body1 } from '../../atoms';

import './bundles-sort.styles.scss';

export interface IBundlesSortProps {
	value: string;
	changeSort: (value: string) => void;
}

export function BundlesSortComponent(props: IBundlesSortProps): ReactElement {
	const { value, changeSort } = props;
	const { t } = useTranslation('general');

	function handleSortChange(
		event: ChangeEvent<{
			name?: string | undefined;
			value: unknown;
		}>
	): void {
		const value: string = event.target.value as string;
		changeSort(value);
	}

	return (
		<Box className="bundles-sort">
			<Body1>{t('sort.sortTitle')}</Body1>
			<FormControl variant="outlined">
				<Select
					margin="dense"
					onChange={handleSortChange}
					value={value}
					IconComponent={KeyboardArrowDown}
				>
					<MenuItem value="ascending">
						{t('sort.nameAscending')}
					</MenuItem>
					<MenuItem value="descending">
						{t('sort.nameDescending')}
					</MenuItem>
				</Select>
			</FormControl>
		</Box>
	);
}
